import { render, staticRenderFns } from "./logoIcon.vue?vue&type=template&id=d744a00a"
var script = {}
import style0 from "./logoIcon.vue?vue&type=style&index=0&id=d744a00a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports